import {
  ModalHeader,
  ModalBody,
  ModalFooter,
  Row,
  Col,
  ListGroup,
  ListGroupItem,
} from "reactstrap";
import { TextField, Button, FormControl } from "@mui/material";
import { toast } from "react-toastify";
import React, { useState, useEffect } from "react";
import { Spinner } from "reactstrap";
import { getAllProject } from "../../../api/casp/project";
import  SearchDropDownListPaginationComponent  from "../common/SearchDropDownPaginationList";
import Settings_svg from "../../../assets/images/icons/jam_cog-f.svg";
import { useFormik } from "formik";
import * as Yup from "yup";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import dayjs from "dayjs";
import { Role } from "../../../constants/Role";
import { useSelector } from "react-redux";
import { createAgenda } from "../../../api/casp/agenda";
import { ProjectStatuses } from "../../../constants/Status";
import Drawer from "@mui/material/Drawer";
import CloseIcon from '@mui/icons-material/Close';
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';
import { withTranslation } from "react-i18next";
import { getAllPortfolios } from "../../../api/casp/portfolio";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import { AttachFile } from "@mui/icons-material";
import { AcceptFileType } from "../../../constants/Common";
import { middleTruncate } from "../../../helpers/string_helper";

const CreateAgenda = ({submitEditAccordionReload,  open, onClose, refresh, t }) => {
  const [newAgenda, setNewAgenda] = useState({
    name: "",
    date: "",
    // projectId: null,
    portfolios: null,
    items: [],
    item: "",
    file: null,
  });
  const [agendaCreationLoading, setAgendaCreationLoading] = useState(false);

  const { user } = useSelector((state) => ({
    user: state.Profile.user,
  }));

  // const toggleAgendaCreationModal = () => {
  //   setIsOpen(!isOpen);
  // };

  const agendaValidation = Yup.object().shape({
    name: Yup.string()
      .max(250, t("Too Long!"))
      .strict(true)
      .trim(t('Must not include leading and trailing spaces'))
      .required(t("Please enter name")),
    date: Yup.date()
      .typeError(t("Given date is invalid type"))
      .required(t("Please Enter date")),
    // portfolioId: Yup.number().nullable(),
    portfolios: Yup.object()
    .nullable()
    .required(t("Please select cohort")),

    item: Yup.string()
      .max(250, t("Too Long!"))
      .strict(true)
      .trim(t('Must not include leading and trailing spaces'))
      .typeError(t("Given item is invalid type"))
      .optional(),
      // .when('items', {
      //   is: (items) => items.length > 0,
      //   then: (schema) => schema.optional(),
      //   otherwise: (schema) => schema.required()
      // }),
      file: Yup.mixed()
    .nullable()
    .test(
      "fileSize",
      t("File size should be less than 10 MB"),
      (value) => !value || value.size <= 10 * 1024 * 1024
    ),

  items: Yup.array().min(1, t("Please add at least one item"))
          .required()
  });

  const formik = useFormik({
    initialValues: {
      ...newAgenda,
    },
    validationSchema: agendaValidation,
    validateOnMount: false,
  });

  const handleCreate = async () => {
    try {
      setAgendaCreationLoading(true);
      const formData = new FormData()
      formData.append('name', formik.values.name);
      formData.append('companyId', user.company.id.toString()); // always string for multipart
      formData.append('date', formik.values.date.format('YYYY-MM-DD'));
      formData.append('portfolioId', formik.values.portfolios.id.toString());


    // Optional projectId
    // if (formik.values?.projectId) {
    //   formData.append('projectId', formik.values.projectId.toString());
    // }

      formik.values.items.forEach((item, index) => {
        formData.append(`items[${index}][title]`, item.text);
        formData.append(`items[${index}][file]`, item.file);
      });

      const response = await createAgenda(formData);
      if (response.statusCode === 200) {
        toast.success(response.data.message);
        formik.setValues({
          ...newAgenda
        })
        formik.setFieldTouched()
        onClose();
        setAgendaCreationLoading(false);
        submitEditAccordionReload(response.data.data.date, response.data.data.date)
        refresh(formik.values.date);
      } else {
        toast.error(response.data.message);
        setAgendaCreationLoading(false);
      }
    } catch (err) {
      setAgendaCreationLoading(false);
      toast.error(err.message);
    }
  };

  // function newItemAddition() {
  //   if (formik.values.items.length >= 10) {
  //     return toast.error("You cannot add more than 10 item.");
  //   }

  //   formik.setFieldTouched("item", false, false);
  //   formik.setValues({
  //     ...formik.values,
  //     items: [...formik.values.items, formik.values.item],
  //     item: "",
  //   });
  // }

  // function removeTask(index) {
  //   const items = formik.values.items.filter((_, i) => i !== index);
  //   formik.setValues({
  //     ...formik.values,
  //     items: items,
  //   }, true);
  // }

  function newItemAddition() {
    if (formik.values.items.length >= 10) {
      return toast.error("You cannot add more than 10 items.");
    }

    const newDescription = formik.values.item.trim().toLowerCase();
    const existingDescriptions = formik.values.items.map((i) =>
      i.text.trim().toLowerCase()
    );

    if (existingDescriptions.includes(newDescription)) {
      toast.error("File Name must be unique");
      return;
    }

    formik.setFieldTouched("item", false, false);
    formik.setValues({
      ...formik.values,
      items: [
        ...formik.values.items,
        {
          text: formik.values.item,
          file: formik.values.file,
        },
      ],
      item: "",
      file: null,
    });
  }

  // console.log('formik',formik.values);
  

  function removeTask(index) {
    const items = formik.values.items.filter((_, i) => i !== index);
    formik.setValues({
      ...formik.values,
      items,
    });
  }

  const handleClose = () => {
    setAgendaCreationLoading(false);
  }

  return (
    <React.Fragment>
      <Drawer
        anchor="right"
        open={open}
        onClose={onClose}
        PaperProps={{
            sx: { width: "580px" },
        }}
        className="projectListDrawer addRiskDrawer"
      >
        <form className="p-3">
          <h5 className="border-bottom-0">
            {t('Add Course & Agenda')}
          </h5>
          <CloseIcon className="crossIcon" onClick={onClose} />
          {/* <ModalBody> */}
          <div className="innerTbContent">
            <div className="mb-3 plDatepicker">
              {/* <FormControl fullWidth> */}
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoContainer components={["DatePicker"]}>
                    <DatePicker
                      label={t("Course Date") + ' *'}
                      className="form-control"
                      disabled={agendaCreationLoading}
                      format="MM/DD/YYYY"
                      name="date"
                      // minDate={dayjs(new Date())}
                      value={
                        formik?.values?.date?.toString().trim()
                          ? formik.values.date
                          : null
                      }
                      on
                      slotProps={{
                        field: {
                          clearable: true,
                          onBlur: (_) => {
                            if (!formik.touched?.date) {
                              formik.setFieldTouched("date", true, false);
                            }
                          },
                        },
                        onClear: () => {
                          formik.setFieldValue("date", "");
                        },
                      }}
                      onChange={(e) => {
                        formik.setFieldValue("date", e ? dayjs(e) : "");
                        if (!formik.touched?.estimatedStartDate) {
                          formik.setFieldTouched("date", true, false);
                        }
                      }}
                      required
                    />
                  </DemoContainer>
                </LocalizationProvider>
              {/* </FormControl> */}
              {formik.touched.date && formik.errors.date && (
                <span className="text-danger">{formik.errors.date}</span>
              )}
            </div>
            <div className="mb-3">
              <TextField
                id="outlined-basic"
                label={t("Course Name")}
                name="name"
                disabled={agendaCreationLoading}
                value={formik.values.name}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                fullWidth
                required
              />
              {formik.touched.name && formik.errors.name && (
                <span className="text-danger">{formik.errors.name}</span>
              )}
            </div>
            <div className="plSelectTypeField mb-3">
              <SearchDropDownListPaginationComponent
                label={t("Cohort") + " *"}
                searchEnabled={false}
                // readOnly={isReadable}
                listCall={getAllPortfolios}
                disableClearable={!formik.values.portfolios}
                // defaultValue={Object.keys(formik.values.portfolios).length !== 0 ? formik.values.portfolios : undefined}
                apiParams={{
                    order: "updatedAt",
                    direction: "desc",
                    ...(![
                        Role.PROJECT_MANAGER,
                        Role.EPMO_MANAGER,
                        Role.ROOT_ADMIN,
                        Role.VICE_PRESIDENT,
                        Role.PRESIDENT,
                        Role.PROGRAM_MANAGER,
                        Role.EPMO_OFFICER,
                        Role.MENTOR
                    ].includes(user?.role?.name) && {
                        filterFields: "portfolioUser",
                        filterInputs: user.id,
                    }),
                }}
                emitItem={(newValue) => {
                    formik.setFieldTouched("portfolios", true, true);
                    formik.setFieldValue(
                        "portfolios",
                        newValue ? newValue : {}
                    );
                }}
                onBlur={() => {
                    if (!formik.touched?.portfolios) {
                        formik.setFieldTouched("portfolios", true, true);
                    }
                }}
              />
              {formik.touched.portfolios && formik.errors.portfolios && (
                  <span className="text-danger">
                      {formik.errors.portfolios}
                  </span>
              )}
            </div>
            {/* <div className="d-flex align-items-center mb-3">
                  <TextField
                    id="outlined-multiline-static"
                    label={t("Agenda Item")}
                    variant="outlined"
                    name="item"
                    disabled={agendaCreationLoading}
                    fullWidth
                    value={formik.values.item}
                    onChange={formik.handleChange}
                    onBlur={() => {
                      // if (
                      //   !(formik.values.item || formik?.values?.items?.length) &&
                      //   !formik.touched.item
                      // ) {
                        formik.setFieldTouched("item", true, false);
                      // }
                    }}
                  />
                  {formik.touched.item && formik.errors.item && (
                    <span className="text-danger">{formik.errors.item}</span>
                  )}
                  <i
                    className={`las la-plus-circle d-inline-block ms-3 fw-semibold fs-22 text-secondary ${
                      formik.errors.item || agendaCreationLoading || !formik.values.item.trim() ? "text-secondary" : ""
                    }`}
                    style={{cursor: agendaCreationLoading || formik.errors.item || !formik.values.item.trim() ? 'not-allowed' : 'pointer'}}
                    onClick={(e) => {
                      if (agendaCreationLoading || formik.errors.item || !formik.values.item.trim()) {
                        e.preventDefault();
                        return
                      }
                      if (formik.values.item) {
                        newItemAddition();
                      } else if (
                        !formik.touched?.item &&
                        !formik.values.items.length
                      ) {
                        formik.setFieldTouched("item", true, true);
                      }
                    }}
                  ></i>
            </div> */}
            {/* <ListGroup className="mt-2">
              {formik.values.items.map((item, index) => (
                <ListGroupItem
                  key={`${item} - ${index}`}
                  className="justify-content-between d-flex"
                  style={{marginBottom: '6px', border: '1px solid #EBEDF5', borderRadius: '5px'}}
                >
                  <div className="d-flex">
                    <AssignmentOutlinedIcon className="rounded_ico" />
                    <span className="text_secondary ms-1" style={{ color: 'rgb(107, 112, 131)', display: 'inline-block',
                        width: 'calc(100% - 70px)'}}>{item}</span>
                  </div>
                    <CloseIcon 
                      className={`las la-times-circle fs-22 text-secondary ${
                        agendaCreationLoading
                          ? "text-secondary"
                          : ""
                      }`}
                      style={{cursor: agendaCreationLoading ? 'not-allowed' : 'pointer' }}
                      disabled={agendaCreationLoading}
                      onClick={() => removeTask(index)}
                    />
                </ListGroupItem>
              ))}
            </ListGroup> */}


            <div className="col-sm-12 mb-3 mt-3">
              <>
                <div className="d-flex align-items-center gap-3 mb-3">
              {/* File Name Field (Half Width) */}
              <div style={{ flex: 1 }}>
                <TextField
                  fullWidth
                  id="agendaItem"
                  label={t("File Name")}
                  name="item"
                  disabled={agendaCreationLoading}
                  value={formik.values.item}
                  onChange={formik.handleChange}
                  onBlur={() => formik.setFieldTouched("item", true, false)}
                  type="text"
                />
                {formik.touched.item && formik.errors.item && (
                  <span className="text-danger">{formik.errors.item}</span>
                )}
              </div>

                {/* File Upload */}
                <div
                  className="d-flex align-items-center position-relative"
                  style={{
                    flex: 1,
                    border: "1px solid #ccc",
                    borderRadius: "5px",
                    padding: "8px 12px",
                    cursor: agendaCreationLoading ? "not-allowed" : "pointer",
                  }}
                >
                  <AttachFile className="attachment_button me-2" />
                  <span className="text-truncate" style={{ flex: 1 }}>
                    {formik.values.file ? middleTruncate(formik.values.file.name) : t("Attach Document")}
                  </span>

                  <input
                    type="file"
                    accept={AcceptFileType.toString()}
                    name="file"
                    onChange={(e) => {
                      const file = e.target.files[0];
                      formik.setFieldValue("file", file || null);
                    }}
                    onBlur={() => {
                      if (!formik.touched?.file) {
                        formik.setFieldTouched("file", true, false);
                      }
                    }}
                    style={{
                      opacity: 0,
                      position: "absolute",
                      top: 0,
                      left: 0,
                      height: "100%",
                      width: "100%",
                      cursor: agendaCreationLoading ? "not-allowed" : "pointer",
                    }}
                  />
                </div>

                  {/* Plus Icon */}
                  <i
                    className={`las la-plus-circle fw-semibold fs-22 ${
                      agendaCreationLoading ||
                      !formik.values.item.trim() ||
                      !formik.values.file ||
                      formik.errors.file
                        ? "text-secondary"
                        : "text-success"
                    }`}
                    style={{
                      cursor:
                        agendaCreationLoading ||
                        !formik.values.item.trim() ||
                        !formik.values.file ||
                        formik.errors.file
                          ? "not-allowed"
                          : "pointer",
                    }}
                    onClick={(e) => {
                      if (
                        agendaCreationLoading ||
                        !formik.values.item.trim() ||
                        !formik.values.file ||
                        formik.errors.file
                      ) {
                        e.preventDefault();
                        return;
                      }
                      newItemAddition();
                    }}
                  ></i>
                </div>

                {/* File Validation Message */}
                {formik.touched.file && formik.errors.file && (
                  <span className="text-danger">{formik.errors.file}</span>
                )}

                {/* Added Agenda Items */}
                {!agendaCreationLoading && formik.values.items.length > 0 && (
                  <h5 className="mb-0 mt-2">{t("Added Course Items")}:</h5>
                )}

                <div>
                  {formik.values.items.length > 0 &&
                    formik.values.items.map((itemObj, index) => (
                      <div
                        className="d-flex mt-2 justify-content-between align-items-center"
                        key={index}
                        style={{
                          border: "1px solid #EBEDF5",
                          borderRadius: "5px",
                          padding: "6px 10px",
                        }}
                      >
                        <div className="d-flex align-items-center">
                          <AssignmentOutlinedIcon className="rounded_ico" />
                          <span
                            className="fw-semibold text-truncate ms-2"
                            title={itemObj.text}
                            style={{ maxWidth: "250px" }}
                          >
                            {itemObj.text}
                          </span>
                          {itemObj.file && (
                            <div className="d-flex align-items-center ms-4 text-truncate">
                              <i className="ri-attachment-2 text-muted me-2" style={{ fontSize: '1rem' }}></i>
                              <span
                                className="text-muted text-truncate"
                                title={itemObj.file.name}
                                style={{ maxWidth: '200px' }}
                              >
                                {middleTruncate(itemObj.file.name)}
                              </span>
                            </div>
                          )}
                        </div>
                        <CloseIcon
                          className="text-danger"
                          style={{
                            cursor: agendaCreationLoading ? "not-allowed" : "pointer",
                          }}
                          onClick={() => removeTask(index)}
                        />
                      </div>
                    ))}
                </div>
              </>
            </div>
          </div>
          {/* </ModalBody> */}
          {/* <ModalFooter className="border-top-0"> */}
          <div className="plsubmitButton">
            <Button
              className="submitBtn btn addNew_ProjectBtn"
              onClick={handleCreate}
              variant="contained"
              color="success"
              disabled={agendaCreationLoading || !formik.isValid || !formik.dirty}
              sx={{
                cursor: agendaCreationLoading || !formik.isValid || !formik.dirty ? 'not-allowed' : 'pointer'
              }}
            >
              {agendaCreationLoading && (
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                  className="me-1"
                />
              )}
              <span className="visually-hidden">Loading...</span>
              <span style={{ textTransform: 'none' }}>{t('Submit')}</span>

            </Button>
          </div>
          {/* </ModalFooter> */}
        </form>
      </Drawer>
    </React.Fragment>
  );
}

export default withTranslation() (CreateAgenda)
